module.exports = __webpack_public_path__ + "img/employer_benefit_scorecentric_mobile.3ea2bcd5.jpg";